import { Component, OnInit } from '@angular/core';
import { SignupForm } from './signup.form';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SessionTokenService } from '../../session/service/session-token';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../shared/storage/local-storage.service';
import { Base64 } from 'js-base64';
import { Subscription } from 'rxjs';
import PasswordValidator from 'password-validator';

@Component({
  selector: 'signup',
  templateUrl: './signup.component.html',
  styleUrls: [ './signup.component.scss' ]
})
export class SignupComponent implements OnInit {

  license: any = {};
  user: any = {};
  completed: boolean = false;
  isTrial = true;
  error: string = '';
  signupPromise: Subscription;
  form: FormGroup;
  isSubmitDisabled: boolean = false;
  passwordValidator: PasswordValidator;
  previewPassword: boolean = false;

  constructor(formBuilder: SignupForm,
              private sessionTokenService: SessionTokenService,
              private httpClient: HttpClient,
              private route: ActivatedRoute,
              private localStorageService: LocalStorageService,
              private router: Router) {
    this.form = formBuilder.buildForm();
  }

  ngOnInit() {
    // if (this.sessionTokenService.isAuthenticated()) {
    //   return this.router.navigate([ '/' ]);
    // }
    this.passwordValidator = new PasswordValidator().is().min(8)
      .has().uppercase()
      .has().lowercase()
      .has().digits()
      .has().not().spaces()
      .has().symbols();

    // this.loadLicense();
  }

  submit() {
    if (this.form.invalid) {
      return;
    }
    this.isSubmitDisabled = true;

    this.signupPromise = this.httpClient.post('/admin/customer', { ...this.form.value, trial: this.isTrial })
      .subscribe((response: any) => {
        this.sessionTokenService.persist(response);
        if (response.user.customer && response.user.customer.customerLicense && response.user.customer.customerLicense.isTrial) {
          this.completed = true;
          this.user = response;
          setTimeout(() => {
            this.router.navigate([ '/campaign' ]);
          }, 2000);
        } else {
          this.router.navigate([ '/setup' ]);
        }
      }, (response) => {
        if (response.error.errors) {
          let error = '';
          response.error.errors.forEach(err => {
            Object.values(err.constraints).forEach(msg => {
              error += `${msg}<br />`;
            });
          });
          this.error = error;
        } else {
          this.error = response.error.message;
        }
        this.isSubmitDisabled = false;
      });
  }
}
